export default ({ store, req }) => {
	store.commit('setIsLoggedIn', !!(req && req.session && req.session.authorization))
}
